import React from "react";
import { Box } from "@mui/material";

// True only under `yarn start` (react-scripts dev server). `react-scripts
// build` always sets NODE_ENV to "production", so this is a constant `false`
// in every build and the minifier drops everything guarded by it.
export const IS_DEV = process.env.NODE_ENV === "development";

// Dev-only overlay: a deliberately ugly grey "DEV" tag in the top-left corner
// plus a tight, hard grey edge fading inward around the whole screen, so a
// local tab is never mistaken for production. Fixed and click-through: it
// sits above everything without moving any layout. Every 5s the edge
// "breathes" (swells inward and settles back) to catch the eye.
const EDGE_REST =
  "inset 0 0 0 2px rgba(80, 80, 80, 0.9), inset 0 0 10px 3px rgba(80, 80, 80, 0.85)";
const EDGE_PEAK =
  "inset 0 0 0 3px rgba(80, 80, 80, 0.95), inset 0 0 40px 12px rgba(80, 80, 80, 0.8)";

const DevIndicator: React.FC = () =>
  IS_DEV ? (
    <Box
      aria-hidden
      sx={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 99999,
        boxShadow: EDGE_REST,
        "@keyframes devEdgeBreathe": {
          "0%, 60%, 100%": { boxShadow: EDGE_REST },
          "80%": { boxShadow: EDGE_PEAK },
        },
        animation: "devEdgeBreathe 5s ease-in-out infinite",
        "@media print": { display: "none" },
      }}
    >
      <Box
        component="span"
        sx={{
          position: "absolute",
          top: 6,
          left: 6,
          px: 0.75,
          py: 0.25,
          backgroundColor: "#8a8a8a",
          color: "#e6e6e6",
          border: "2px dashed #555",
          fontFamily: '"Courier New", monospace',
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: 2,
          lineHeight: 1,
          transform: "rotate(-4deg)",
          userSelect: "none",
        }}
      >
        DEV
      </Box>
    </Box>
  ) : null;

export default DevIndicator;
